import { API_BASE_URL } from "../constants/payment";

function httpError(status, message) {
  const error = new Error(message);
  error.status = status;
  return error;
}

export function isErrorPayload(data) {
  if (!data || typeof data !== "object") return false;
  if (data.success === false || data.ok === false) return true;
  if (typeof data.status === "string" && data.status.toLowerCase() === "error") {
    return true;
  }
  return Boolean(data.error || data.errors);
}

export function getGuidFromUrl() {
  const path = window.location.pathname;
  const parts = path.split("/");

  return (
    parts[parts.length - 1] ||
    new URLSearchParams(window.location.search).get("guid")
  );
}

let orderPrefetchPromise;

export function prefetchOrder() {
  if (orderPrefetchPromise !== undefined) return orderPrefetchPromise;

  const guid = getGuidFromUrl();
  if (!guid) {
    orderPrefetchPromise = null;
    return null;
  }

  orderPrefetchPromise = fetchOrderData(guid);
  orderPrefetchPromise.catch(() => {});
  return orderPrefetchPromise;
}

export function getPrefetchedOrder() {
  return orderPrefetchPromise ?? null;
}

export async function fetchOrderData(guid) {
  const response = await fetch(`${API_BASE_URL}/order/${guid}`);

  if (!response.ok) {
    throw httpError(response.status, "Order not found");
  }

  return response.json();
}

const MOCK_FIXTURES = {
  default: "/order.json",
  inr: "/order-inr.json",
  krw: "/order.json",
  "krw-bank": "/order-public-krw-bank.json",
};

function getMockFixtureUrl() {
  try {
    const key = new URLSearchParams(window.location.search)
      .get("mock")
      ?.toLowerCase();
    return MOCK_FIXTURES[key] || MOCK_FIXTURES.default;
  } catch {
    return MOCK_FIXTURES.default;
  }
}

export async function fetchLocalOrderData() {
  const response = await fetch(getMockFixtureUrl());

  if (!response.ok) {
    throw new Error("Mock order not found");
  }

  return response.json();
}

export async function submitUtr(guid, utr) {
  const response = await fetch(`${API_BASE_URL}/order/${guid}/submit-utr`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ utr }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || isErrorPayload(data)) {
    throw httpError(
      response.status,
      data.message || data.error || "Failed to submit UTR",
    );
  }

  return data;
}
